/* eslint-disable react/jsx-props-no-spreading */
import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';

import useTopics from '../../hooks/useTopics';
import { getComponentFromName } from '@folklore/utils';

import * as CardComponents from '../cards/taxonomies';
import PresentationList from './PresentationList';

import styles from '../../styles/lists/categories-list.module.css';

const propTypes = {
    cardComponent: PropTypes.elementType,
    cardType: PropTypes.string,
    className: PropTypes.string,
    cardClassName: PropTypes.string,
};

const defaultProps = {
    cardComponent: null,
    cardType: null,
    className: null,
    cardClassName: null,
};

function TopicsList({ cardType, cardComponent, className, cardClassName, ...props }) {
    return (
        <PresentationList
            hook={useTopics}
            {...props}
            cardComponent={
                cardComponent ||
                getComponentFromName(CardComponents, cardType, CardComponents.Vertical)
            }
            className={classNames([
                styles.container,
                {
                    [className]: className !== null,
                },
            ])}
            cardClassName={classNames([
                styles.card,
                {
                    [cardClassName]: cardClassName !== null,
                },
            ])}
        />
    );
}

TopicsList.propTypes = propTypes;
TopicsList.defaultProps = defaultProps;

export default TopicsList;
